export function Brand() {
  return (
    <div className="brand" aria-label="Expense Analyzer by Ciminaghi">
      <div className="brand-mark">
        <img src="/android-chrome-192x192.png" alt="" />
      </div>
      <div>
        <div className="brand-title">EXPENSE ANALYZER</div>
        <div className="brand-subtitle">by Ciminaghi</div>
      </div>
    </div>
  );
}
